import React from 'react';
import { Link } from 'react-router-dom';

/**
 * The ONE permitted env-var conditional in the V2 work (plan §5.1). amplify.yml
 * appends REACT_APP_UI_V2_ENTRY=true to .env.production for gen2-dev and
 * gen2-main alike (since 2.5.0, when V2 opened to the production userbase),
 * and scripts/start-local.sh writes it to .env.local. Dropping the flag from a
 * branch hides the button without touching the router, which is the real
 * switch. Since CONF-201 (2.6.0) V2 is the default route, so from classic
 * (/classic) this button returns to `/`.
 */
export const V2_ENTRY_ENABLED = process.env.REACT_APP_UI_V2_ENTRY === 'true';

type Props = { enabled?: boolean };

export function TryNewLookButton({ enabled = V2_ENTRY_ENABLED }: Props) {
  if (!enabled) return null;
  return (
    <Link
      to="/"
      className="border-2 border-flash text-flash px-4 py-2 mx-2 rounded hover:bg-flash hover:text-ground transition duration-300"
    >
      Switch to the new look
    </Link>
  );
}

export default TryNewLookButton;
